import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var IS_SEARCH_ENGINE = 'IS_SEARCH_ENGINE';
export var SET_SEARCH_ENGINE_STATUS = 'SET_SEARCH_ENGINE_STATUS';
export var IS_SEARCH_ENGINE_ACTION = 'IS_SEARCH_ENGINE_ACTION';